import { TextConfigurationTextProperties } from '@/types';

export const getTextPrintColor = (text: TextConfigurationTextProperties) => {
  const printColorId = text.printColorId;
  if (!printColorId) {
    return { printColorRGBs: text.fill };
  }

  return { printColorId };
};
